// wrapper to avoid having to do the ${sat.locale} thing all the time, and to avoid confusing phpstorm
// whenever import paths change
import(
    /* webpackMode: "lazy-once" */
    `./sat/${sat.locale}.js`
);
